<template >
    <div id="careers-detail" class="section sticky-footer">
        <h1 class="section-title lockout" ref="sectionTitle">Careers</h1>

        <div class="hero">
            <div class="hero__text">
                <div class="hero__text__bg">
                    <div class="hero__text__bg__wrap">
                        <h4 class="hero__text__subtitle">{{ data.game }}</h4>
                        <h1 class="hero__text__title">{{ data.title }}</h1>
                    </div>
                </div>
            </div>
            <div class="hero__image" style="background-image: url('/img/careers/hero-image-detail2.jpg')">
                <div class="hero__image__white"></div>
                <a v-if="data.applyUrl" :href="data.applyUrl" target="_blank">
                    <div class="btn btn--huge hero__image__apply-btn">
                        <div class="btn--huge__text">
                            <div>APPLY<span>APPLY</span></div>
                        </div>
                    </div>
                </a>
            </div>
        </div>

        <div class="job lockout lockout--careers">
            <div class="job__desc">
                <h1>JOB DETAILS:</h1>
                <!--<h2>THIS IS PLACEHOLDER COPY, YET TO BE DETERMINED WHAT DATASHOULD GO HERE</h2>-->
                <!--<h4>WHAT YOU'LL DO:</h4>-->
                <div>
                    <div class="job__desc__info">
                        <div class="job__desc__info__field field--location">
                            <strong>Locations</strong>
                            <p v-html="data.location"></p>
                        </div>
                        <div class="job__desc__info__field">
                            <strong>Role ID</strong>
                            <p v-html="data.jobId"></p>
                        </div>
                        <div class="job__desc__info__field">
                            <strong>Worker Type</strong>
                            <p v-html="data.req_type"></p>
                        </div>
                        <div class="job__desc__info__field">
                            <strong>Studio/Department</strong>
                            <p v-html="data.studio"></p>
                        </div>
                        <div class="job__desc__info__field">
                            <strong>Work Model</strong>
                            <p v-html="data.work_model"></p>
                        </div>
                    </div>
                </div>
                <h2>Description & Requirements</h2>
                <p>Electronic Arts creates next-level entertainment experiences that inspire players and fans around the world. Here, everyone is part of the story. Part of a community that connects across the globe. A place where creativity thrives, new perspectives are invited, and ideas matter. A team where everyone makes play happen.</p>
                <div class="job__feed" v-html="data.description" ref="description"></div>
                <div>
                    <p><strong>About Electronic Arts</strong></p>
                    <p>We're proud to have an extensive portfolio of games and experiences, locations around the world, and opportunities across EA. We value adaptability, resilience, creativity, and curiosity. From leadership that brings out your potential, to creating space for learning and experimenting, we empower you to do great work and pursue opportunities for growth.</p>
                    <p>We adopt a holistic approach to our benefits programs, emphasizing physical, emotional, financial, career, and community wellness to support a balanced life. Our packages are tailored to meet local needs and may include healthcare coverage, mental well-being support, retirement savings, paid time off, family leaves, complimentary games, and more. We nurture environments where our teams can always bring their best to what they do.</p>
                    <p>Electronic Arts is an equal opportunity employer. All employment decisions are made without regard to race, color, national origin, ancestry, sex, gender, gender identity or expression, sexual orientation, age, genetic information, religion, disability, medical condition, pregnancy, marital status, family status, veteran status, or any other characteristic protected by law. We will also consider employment qualified applicants with criminal records in accordance with applicable law. EA also makes workplace accommodations for qualified individuals with disabilities as required by applicable law.</p>
                </div>
                <!--
                <h2 class="opportunity">The opportunity to create groundbreaking games with some of the best developer
                    talent in the
                    industry awaits our future team members. </h2>
                    -->

                <a v-if="data.applyUrl" :href="data.applyUrl" target="_blank">
                    <div class="btn btn--huge">
                        <div class="btn--huge__text">
                            <div>APPLY NOW<span>APPLY NOW</span></div>
                        </div>
                    </div>
                </a>

            </div>
            <div class="job__companies">
                <!--
                <h3>
                    Requisition Number: {{ data.reqId }}<br>
                    Location: {{ data.location }}<br>
                    Date Opened: {{ data.dateOpened }}
                </h3>
                <div class="about__group">
                    <h2>ABOUT EA</h2>
                    <p>Electronic Arts Inc. is a leading global interactive entertainment software company. EA delivers
                        games, content and online services for Internet-connected consoles, personal computers, mobile
                        phones and tablets.</p>
                </div>
                <div class="about__group">
                    <h2>ABOUT RESPAWN</h2>
                    <p>Respawn Entertainment is a AAA game development studio that was founded in 2010 by former
                        co-founders of Infinity Ward and creators of the multi-billion dollar Call of Duty and Modern
                        Warfare franchises. In 2017, Respawn was acquired by Electronic Arts, a leading global
                        interactive entertainment publisher. We have shipped Titanfall and Titanfall 2 to critical
                        acclaim, and are currently hiring for our Star Wars ™, Titanfall, and Unannounced VR game
                        development teams. Our motto is gameplay first, and the opportunity to create groundbreaking
                        games with some of the best developer talent in the industry awaits our future team members.</p>
                    <p>We’re looking for highly skilled Level Designer who will embrace our philosophy and share
                        his/her hard earned expertise to create an incredible experience for our players. If this sounds
                        like you, we're looking forward to seeing your resume!</p>
                </div>
                -->
                <div class="job__share">
                    <h2>SHARE THIS JOB</h2>
                    <ul class="job__share__icons">
                        <li>
                            <a :href="'https://www.facebook.com/sharer.php?u=https://www.respawn.com' + currentURL " target="_blank" >
                                <img src="../img/global/share/facebook.png" alt="Facebook">
                            </a>
                        </li>
                        <li>
                            <a :href="'https://www.linkedin.com/shareArticle?mini=true&title=Check out this job: &url=https://www.respawn.com' + currentURL " target="_blank" >
                                <img src="../img/global/share/linkedin.png" alt="Linked In">
                            </a>
                        </li>
                        <li>
                            <a :href="'https://twitter.com/intent/tweet?text=Check out this job: https://www.respawn.com' + currentURL " target="_blank" >
                                <img src="../img/global/share/twitter.png" alt="Twitter">
                            </a>
                        </li>
                        <li>
                            <a :href="'mailto:?subject=Check out this job&body=Check out this job:%0D%0Ahttps://www.respawn.com' + currentURL " target="_blank" >
                                <img src="../img/global/share/email.png" alt="Email">
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="other__jobs">
                    <h2>OTHER JOBS</h2>
                    <ul class="other__jobs__positions">
                        <li v-for="position in data.positions">
                            <a :href="position.link" data-router-link >
                                <h4 class="other__jobs__positions__title">{{position.title}}</h4>
                                <h5 class="other__jobs__positions__game">{{position.game}}</h5>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <router-view/>
        <footer-bar></footer-bar>

    </div>
</template>

<script>


    import Footer from '@/components/Footer'
    import SectionTitle from '../lib/SectionTitle'
    import axios from 'axios'
    import $ from 'jquery'
    import inobounce from 'inobounce'
    import siteHelpers from "@/helpers/siteHelpers"
    import { nextTick } from 'vue';
    import {gsap, Power3} from "gsap";

    export default {
        name: 'careers-detail-inner',
        metaInfo() {
            return siteHelpers.getGlobalMeta(this.data.title, this.data.title + ' | Careers')
        },
        components: {
            'footer-bar': Footer
        },
        data() {
            return {
                remounterKeyCareersDetail:'',
                data: {},
                currentURL: window.location.pathname
            }
        },
        computed: {
            remounterKey: {
                get: function () {
                    return this.$store.state.remounterKey;
                },
                set: function (value) {

                }
            }
        },
        watch: {
            remounterKey: function () {
                this.remounterKeyCareersDetail = this.$store.state.remounterKey
                this.forceUpdate();
            }
        },
        mounted() {
            this.loadJson();
        },
        methods: {

            loadJson() {
                const routeId = this.$route.params.id
                const urlparams = (this.$helpers && this.$helpers.getURLParameters)
                    ? this.$helpers.getURLParameters(this.$route.query)
                    : ''

                // Pull the lightweight listing info from careers.json (title/game/location), if present.
                const careersData = window.careers && window.careers.data
                let summary = null
                if (careersData && Array.isArray(careersData.categories)) {
                    for (let i = 0; i < careersData.categories.length; i++) {
                        const cat = careersData.categories[i]
                        if (!cat || !Array.isArray(cat.positions)) continue
                        for (let j = 0; j < cat.positions.length; j++) {
                            const pos = cat.positions[j]
                            if (!pos) continue
                            if (pos.id === routeId) {
                                summary = { ...pos, group: cat.title }
                                break
                            }
                        }
                        if (summary) break
                    }
                }

                const buildOtherJobs = () => {
                    const flat = window.careers && window.careers.calculated && window.careers.calculated.categoriesFlat
                    if (!Array.isArray(flat)) return []
                    return flat
                        .filter(p => p && p.id && p.id !== routeId)
                        .slice(0, 6)
                        .map(p => ({
                            title: p.role,
                            game: p.team,
                            location: p.location,
                            link: '/careers/' + p.id
                        }))
                }

                const finalize = () => {
                    // dynamic meta title load
                    if (this.data && this.data.title) {
                        $('head title').html(this.data.title + ' | Careers | ' + this.$siteName)
                    }
                    nextTick(() => {
                        this.onJsonLoaded()
                    })
                }

                // Always try to load the full per-job JSON first (matches live-site behavior).
                // If it 404s locally, fall back to the lightweight summary from careers.json.
                axios.get(window.baseUrl + '/careers/' + routeId + '.json' + urlparams)
                    .then((response) => {
                        const job = response.data || {}

                        // Enrich with listing info if missing
                        if (summary) {
                            if (!job.title) job.title = summary.title
                            if (!job.game) job.game = summary.game
                            if (!job.category) job.category = summary.group
                            if (!job.location) job.location = summary.location
                        }

                        // Normalize schema: location as array of strings
                        if (job.location !== undefined) {
                            job.location = Array.isArray(job.location) ? job.location : [job.location]
                        }

                        // Ensure other jobs list exists (some job json may omit it)
                        if (!Array.isArray(job.positions)) {
                            job.positions = buildOtherJobs()
                        }

                        // Ensure description exists so the page isn't visually empty
                        if (!job.description) {
                            job.description = '<p>Job details are not available for this role in this environment.</p>'
                        }

                        this.data = job
                        finalize()
                    })
                    .catch((error) => {
                        // Fall back to summary data
                        if (summary) {
                            const job = { ...summary }
                            job.location = Array.isArray(job.location) ? job.location : [job.location]
                            job.positions = buildOtherJobs()
                            job.description = '<p>Job details are not available for this role in this environment.</p>'
                            job.applyUrl = job.applyUrl || ''
                            this.data = job
                            finalize()
                        } else {
                            console.error(error)
                        }
                    })
            },

            onJsonLoaded() {
                setTimeout(() => {
                    this.$store.commit('endSectionPreload');
                }, 500);

                $(this.$refs.description).find('*').removeAttr('style');
                $('a[data-router-link]').on('click', this.onRouterLinkClick);


                //shrink title if tons of words
                var big_title = $('.hero .hero__text__title');
                //$('.hero .hero__text__title').html('sdkjsf fgkjfdkjfsdhg skfjdgkdjfgdskfjg dkjgdfkgdfgdjkgfdjksfg');
                //$('.hero .hero__text__title').html('A job title goes sjksfdjfgdfhgj dfh sdfkjke jk for se');
                var big_title_chararacter_count = big_title.text().length;
                if (big_title.length) {
                    var fs = "70px";
                    var lh = "74px";
                    if (big_title_chararacter_count>50) {
                        fs = "45px";
                        lh = "49px";
                    } else if (big_title_chararacter_count>40) {
                        fs = "50px";
                        lh = "54px";
                    } else if (big_title_chararacter_count>30) {
                        fs = "60px";
                        lh = "64px";
                    }
                    big_title.css({"font-size":fs,"line-height":lh});
                }


                inobounce.disable();
                SectionTitle.animateIn(this.$refs.sectionTitle);
                this.animateIn();
            },

            animateIn() {
                this.$helpers.globalPostLoad();

                var isMobile = $(window).width() < 700;
                var $orangeHero = $('.hero__text__bg');
                var $whiteImageBlocker = $('.hero__image__white');
                var $applyBtn = $('.hero__image__apply-btn');
                var narrowOrange = $orangeHero.width() * 0.3;
                var targetX = $orangeHero.width() + (isMobile ? 0 : 230);
                var orangeStartingHeight = $orangeHero.outerHeight();
                var $text = $('.hero__text__bg__wrap');
                var $job = $('.job');

                var tl = gsap.timeline();
                tl.delay(this.$store.state.firstSection ? 0 : 0.65);

                tl.set($orangeHero, {width: $orangeHero.width() * 0.3, height: orangeStartingHeight})
                tl.fromTo($orangeHero, 1, {x: -narrowOrange, force3D: true},
                    {x: targetX, force3D: true, ease: Power3.easeInOut});
                tl.to($orangeHero, 0.6, {
                    x: 0,
                    width: '100%',
                    force3D: true,
                    ease: Power3.easeInOut,
                    clearProps: 'all'
                }, '-=0.21');
                tl.fromTo($whiteImageBlocker, 0.6, {xPercent: 0}, {
                    xPercent: -100,
                    force3D: true,
                    ease: Power3.easeInOut
                }, '-=0.55');
                tl.fromTo($applyBtn, 0.7, {xPercent: 100, opacity:0}, {
                    xPercent: 0,
                    opacity: 1,
                    force3D: true,
                    ease: Power3.easeInOut
                }, '-=0.52');

                tl.fromTo($text, 0.45, {x: 200, opacity: 0}, {
                    x: 0,
                    opacity: 1,
                    force3D: true,
                    ease: Power3.easeOut
                }, 1.12);
                tl.fromTo($job, 0.7, {y: 100, opacity: 0}, {
                    y: 0,
                    force3D: true,
                    opacity: 1,
                    ease: Power3.easeInOut
                }, '-=0.6');

            },

            onRouterLinkClick(e) {
                e.preventDefault();
                let href = $(e.currentTarget).attr('href');
                this.$router.push({ path: href });
            },

        },

        unmounted() {

        }

    }

</script>
